import React, { useState, useEffect, useRef, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './DublinRoofingSection.css';
import '../all/Main.css';

import dublin from '../../../assets/ReynoldsburgPage/Roofing Services/Residential_Roof_Repair_Reynoldsburg_Ohio_ultimatesroofing.png';
import dublina from '../../../assets/ReynoldsburgPage/Roofing Services/Residential_Roof_Replacement_Reynoldsburg_Ohio_Ultimatesroofing.webp';
import dublin1 from '../../../assets/ReynoldsburgPage/Roofing Services/Residential_Roof_Installation_Reynoldsburg_Ohio_Ultimatesroofing.webp';
import dublin2 from '../../../assets/ReynoldsburgPage/Roofing Services/storm_damage_roof_Reynoldsburg_Ohio_Ultimatesroofing.jpg';
import dublin3 from '../../../assets/ReynoldsburgPage/Roofing Services/gutter_repair_system_Reynoldsburg_Ohio_Ultimatesroofing.jpg';
import dublin4 from '../../../assets/ColumbusPage/Siding/siding_repair_columbus_ohio.jpg'; // fallback

import AnimatedButton from '../RoofingSection/AnimatedButton';
import Badge from '../ServiceSection/Badge';
import { Link } from 'react-router-dom';

const DublinRoofingSection = () => {
  const sectionRef = useRef(null);
  const headerRef = useRef(null);
  const cardEls = useRef([]);
  const [scrollProg, setScrollProg] = useState(0);

  const services = [
    {
      title: "Roof Repair",
      desc: "Fast, reliable roof repairs fixing leaks, damage, and structural roofing issues.",
      icon: "bi-layers",
      image: dublin
    },
    {
      title: "Roof Replacement",
      desc: "Complete roof replacement services using durable materials for long-lasting protection now!",
      icon: "bi-shield-check",
      image: dublina
    },
    {
      title: "Roof Installation",
      desc: "Professional installation ensures strong, energy-efficient roofing systems for new buildings.",
      icon: "bi-tools",
      image: dublin1
    },
    {
      title: "Storm Damage Repair",
      desc: "Our professional roofer help Hail, wind, and water damage repair to restore your roof fast.",
      icon: "bi-cloud-rain-heavy",
      image: dublin2
    },
    {
      title: "Gutter System",
      desc: "Efficient gutter repair services improve drainage and protect your home's foundation.",
      icon: "bi-droplet-half",
      image: dublin3
    },
    {
      title: "Siding Repair",
      desc: "Quality siding installation and repair improve protection, insulation, and exterior appearance.",
      icon: "bi-arrow-repeat",
      image: dublin4
    }
  ];

  const particles = useRef(
    Array.from({ length: 18 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: 55 + Math.random() * 45,
      size: 2 + Math.random() * 3,
      dur: 7 + Math.random() * 10,
      delay: Math.random() * 8
    }))
  ).current;

  useEffect(() => {
    const observers = [];

    // Header animation
    if (headerRef.current) {
      const headerObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            entry.target
              .querySelectorAll('.roofing-badge,.roofing-title,.dublin-desc')
              .forEach(el => el.classList.add('animate-in'));

            headerObserver.disconnect();
          }
        },
        { threshold: 0.2 }
      );

      headerObserver.observe(headerRef.current);
      observers.push(headerObserver);
    }

    // Card animations
    cardEls.current.forEach((card, i) => {
      if (!card) return;

      const cardObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('visible');
            }, i * 120);

            cardObserver.disconnect();
          }
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -40px 0px'
        }
      );

      cardObserver.observe(card);
      observers.push(cardObserver);
    });

    return () => observers.forEach(obs => obs.disconnect());
  }, []);

  // Scroll progress
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const top = rect.top + window.scrollY;
      const height = rect.height;

      const progress = Math.min(
        Math.max(
          (window.scrollY - top + window.innerHeight * 0.5) / height,
          0
        ),
        1
      );

      setScrollProg(progress * 100);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCardMouse = useCallback((e, idx) => {
    const card = cardEls.current[idx];
    if (!card) return;

    const rect = card.getBoundingClientRect();

    card.style.setProperty(
      '--mx',
      `${((e.clientX - rect.left) / rect.width) * 100}%`
    );

    card.style.setProperty(
      '--my',
      `${((e.clientY - rect.top) / rect.height) * 100}%`
    );
  }, []);

  return (
    <section className="cs-section roofing-section" ref={sectionRef}>
      {/* Particles */}
      <div className="roofing-particles" aria-hidden="true">
        {particles.map((p) => (
          <div
            key={p.id}
            className="roofing-particle"
            style={{
              left: `${p.left}%`,
              top: `${p.top}%`,
              width: `${p.size}px`,
              height: `${p.size}px`,
              animationDuration: `${p.dur}s`,
              animationDelay: `${p.delay}s`
            }}
          />
        ))}
      </div>

      {/* Scroll line */}
      <div
        className="roofing-scroll-line"
        style={{ width: `${scrollProg}%` }}
      />

      <div className="container position-relative" style={{ zIndex: 2 }}>
        {/* Header */}
        <div className="roofing-header" ref={headerRef}>
          <div className='cs-badge d-flex justify-content-lg-start justify-content-center'>
        <Badge text="Roofing Services"></Badge></div>

          <h2
            className="cs-title roofing-title col-lg-9 col-12 text-white text-lg-start text-center"
           
          >
            Our Roofing Services Available
            <span className=""> in Reynoldsburg, Ohio</span>
          </h2>

          <p className="cs-desc dublin-desc text-lg-start text-center">
            We provide complete roofing services for homeowners and business owners, including repairs, replacements, and installations for durability and long-term protection.
          </p>
        </div>

        {/* Cards - WITH IMAGE HOVER ICON EFFECT */}
        <div className="row g-4 cs-content">
          {services.map((service, i) => (
            <div className="col-lg-4 col-md-6" key={service.title}>
              <div
                ref={el => (cardEls.current[i] = el)}
                className="roofing-card"
                onMouseMove={(e) => handleCardMouse(e, i)}
              >
                <div className="roofing-card-shine" />
                <span className="roofing-card-num">
                  {String(i + 1).padStart(2, '0')}
                </span>

                {/* IMAGE HOVER → ICON BG CHANGE */}
                <div 
                  className="roofing-card-img-wrap"
                  onMouseEnter={() => {
                    const icon = cardEls.current[i]?.querySelector('.roofing-card-icon');
                    icon?.classList.add('icon-hover');
                  }}
                  onMouseLeave={() => {
                    const icon = cardEls.current[i]?.querySelector('.roofing-card-icon');
                    icon?.classList.remove('icon-hover');
                  }}
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    loading="lazy"
                  />
                </div>

                <div className="roofing-card-content">
                  <div className="roofing-card-icon">
                    <i className={`bi ${service.icon}`} />
                  </div>

                  <h3 className="roofing-card-title">
                    {service.title}
                  </h3>

                  <p className="roofing-card-desc">
                    {service.desc}
                  </p>

<Link
  to="/siding-enhancements"
  className="roofing-card-link"
>
  Learn More
  <i className="bi bi-arrow-right" />
</Link>

    

                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-lg-3 mt-4 d-flex justify-content-center">
          <AnimatedButton />
        </div>
      </div>
    </section>
  );
};

export default DublinRoofingSection;